import type {Partner} from "@hosttools/core/config/types";
import {useContext, useMemo} from "react";

import {UserContext} from "../../contexts/UserContext";

export function usePartner(name: Partner["name"]) {
    const {user} = useContext(UserContext);

    const partner = useMemo(() => {
        return user?.partners.find(partner => partner.name === name);
    }, [user, name]);

    return partner;
}
